// Commission Payable Mutations

export const updateCommissionPayableList = (state, payload) => {
  state.commissionPayableList = payload
}

export const updateCommissionPayableInfo = (state, payload) => {
  state.commissionPayableInfo = payload
}

export const updateCommissionPayableBalanceDetails = (state, payload) => {
  state.commissionPayableBalanceDetails = payload
}
